export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Docente de Instrumentación Quirúrgica · Instituto Superior de Formación Técnica, Buenos Aires',
    'En una tarde tenía más material sobre instrumentación quirúrgica contextualizado en Argentina que en toda mi carrera docente. Ahora mis alumnos me preguntan sobre el Checklist OMS, los protocolos INET 2026 y cómo se instrumenta una colecistectomía laparoscópica en una guardia a las 3 de la mañana, y tengo respuesta fundamentada para todo.',
    'bg-petrol',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Docente de Instrumentación Quirúrgica · Instituto Técnico Superior, Santa Cruz',
    'Mis alumnos por primera vez entendieron la diferencia entre asepsia, antisepsia y esterilización, y analizaron un caso real de retención de cuerpo extraño con argumentos técnicos y protocolos argentinos vigentes. El nivel de participación se multiplicó.',
    'bg-teal',
  ],
  [
    'SP',
    'Sandra P.',
    'Profesora de Instrumentación Quirúrgica · Instituto Superior, Córdoba',
    'Las simulaciones de conteo quirúrgico con los formularios del MEGAPACK son exactamente lo que mis alumnos necesitaban: protocolo real, con contexto argentino, con el Checklist OMS adaptado. Cambió todo.',
    'bg-aqua',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Instrumentación Quirúrgica',
    'Con el MEGAPACK, en una tarde tenía el argumento pedagógico completo para explicar por qué el Checklist Quirúrgico de la OMS redujo la mortalidad quirúrgica un 47% en el estudio piloto de 2009, por qué Argentina lo adoptó por resolución ministerial y por qué ningún cirujano puede omitirlo. Mis alumnos empezaron a ver la instrumentación como una responsabilidad de vida o muerte. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Instrumentación Quirúrgica',
    'Cuando explicás que el Art. 293 del Código Penal argentino penaliza la falsificación de documentos, y que falsificar el registro de conteo quirúrgico para ocultar una discrepancia es un delito penal real, empieza un debate sobre ética y seguridad del paciente que ninguna otra materia genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Instrumentación Quirúrgica',
    'Cuando mis alumnos descubren que la retención de un cuerpo extraño quirúrgico es un evento centinela de notificación obligatoria al Ministerio de Salud, que el instrumentador tiene responsabilidad civil, penal y ético-profesional, y que todo se hubiera prevenido con un conteo correcto de 3 minutos, empieza una conversación que ningún libro de texto provoca.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Instrumentación Quirúrgica',
    'Cerré la planificación anual en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con los protocolos 2026, el marco normativo del INET actualizado y los 150 casos del Bono 2 integrados en cada unidad didáctica.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack + Upsell Premium',
    'Cuando les digo a mis alumnos que el instrumentador que está frente a esa mesa tiene en sus manos el destino de un paciente que le entregó su vida bajo anestesia, y que la diferencia entre una cirugía exitosa y un evento adverso puede ser una gasa sin hilo radioopaco o un conteo omitido, les estoy enseñando lo que significa la responsabilidad profesional.',
  ],
];
